<template>
  <div>
    <div>
      <div>  
        <b-row class="align-center">
            <b-col v-if="!HasServices" class="text-info"><i> {{$t('connector.label.nodata')}}</i></b-col>
          </b-row>      
        <b-button v-if="HasServices" v-b-toggle="'list-invisible-services'" class="m-1" variant="info">
          <span class="when-open"
            ><font-awesome-icon :icon="['fas', 'chevron-up']" />&nbsp;</span
          >
          <span class="when-closed"
            ><font-awesome-icon :icon="['fas', 'chevron-down']" />&nbsp;</span
          >
          {{ $t("connector.label.list_service") }}
        </b-button>
        <b-button v-if="HasImport" 
          variant="warning"
          @click="getFromAPI"
          >{{$t('connector.btn.get_from_api')}}</b-button>
          &nbsp;
          <b-badge variant="dark" v-if="secteurs === null">{{$t('connector.label.nodatanetsoins')}}</b-badge>
          <b-badge variant="success" v-if="secteurs">{{ $t("connector.label.nb_secteurs_netsoins", [secteurs.length])}} </b-badge>
          <b-button v-if="secteurs && !useProxy && connector === 'NETSOIN'" @click="GetLink()">
            <font-awesome-icon :icon="['fas', 'download']" />
              &nbsp;{{ $t("btn.download") }}
          </b-button>
        <b-collapse v-model="listVisible" id="list-invisible-services">
          <b-table
            :fields="fields"
            :items="services"
            small
            responsive="sm"
            :tbody-tr-class="rowClass"
          >
            <template #cell(saved)="row">
               <b-col> 
                  <font-awesome-icon  v-if="row.item.saved" :icon="['fas', 'check-square']" />
                  <font-awesome-icon v-else :icon="['fas', 'square']" />
               </b-col>
            </template>          
            <template #cell(serv_id)="row">
              <b-col>{{ row.item.serv_id }}</b-col>
            </template>
            <template #cell(serv_name)="row">
              <b-col>{{ row.item.serv_name }}</b-col>
            </template>
            <template #cell(serv_is_default)="row">
              <b-badge :variant="row.item.serv_is_default ? 'success' : 'secondary'" >
                {{ row.item.serv_is_default ? $t('label.yes') : $t('label.no')  }}
              </b-badge>
            </template>            
            <template #cell(ext_uri)="row">
              <b-col>
                <b-input-group size="sm">
                <b-form-select id="secteur" 
                  v-b-tooltip.hover :title="(row.item.ext_uri === null) ? '' : row.item.ext_uri"
                  :disabled="row.item.ext_uri === null && ! row.item.serv_is_enable"  v-model="row.item.ext_uri" @input="setModified($event, row.item)">
                  <option :value="null" disabled>{{$t('connector.option.uri')}}</option>
                  <option :key="secteur.Uri" v-for="secteur in secteurs" :value="secteur.Uri" >
                    {{ secteur.Libelle }}
                  </option>
                </b-form-select>
                </b-input-group>
              </b-col>
            </template>
            <template #cell(update)="row">
              <b-row class="details">
                <b-col>
                  <b-button
                  v-b-tooltip.hover :title="$t('connector.tooltip.unmap')"
                  size="sm"
                  @click="Reset(row.item)"
                  :disabled="!(SaveEnabled )"
                  variant="outline-danger"
                  >X
                  </b-button>
                  <span class="d-inline-block" tabindex="0"
                  v-b-tooltip.hover :title="!(SaveEnabled && row.item.modified) ? '' : $t('connector.tooltip.cancel')"
                  >
                  <b-button
                  class="editbtn"
                  size="sm"
                  @click="Undo(row.item)"
                  :disabled="!(SaveEnabled && row.item.modified)"
                  >
                    <font-awesome-icon :icon="['fa', 'undo']" />
                  </b-button>
                  </span>
                  <b-button
                    v-b-tooltip.hover :title="!(SaveEnabled && row.item.modified) ? '' :$t('btn.save')"
                    size="sm"
                    :disabled="!(SaveEnabled && row.item.modified)"
                    @click="SaveMapping(row.item)"
                    :variant="(row.item.modified)? 'danger' :'secondary '"
                    class="editbtn"
                    >
                    <font-awesome-icon :icon="['fas', 'save']" />
                    </b-button
                  ></b-col
                >
              </b-row>
            </template>            
          </b-table>
        </b-collapse>
      </div>
    </div>
  </div>
</template>

<script>
import { normalizeSync } from "normalize-diacritics";
import { MappedServices, SetServiceUri } from "../../services/establishment";
import { Secteurs, SousSecteurs, Links} from "../../services/netsoins";
import ApiTitan, { normalizeTitanSector } from "../../services/titan";
import ApiNetsoins from "../../services/proxyNetsoins";

export default {
  name: "ListServices",
  props: {
    type: {
      type: String,
      default: null,
    },
    keyapi: { 
      type: String,
      default: null 
    },
    urlapi: { 
      type: String, 
      default: null 
    },
    config: {
      type: Object,
      default() { return {} },
    },
    connector: {
      type: String,
      default: 'NETSOIN',
    },
    esta: { type: Number, default: null},
    cnt: { type: Number, default: null},
    ctx: { type: Number, default: null},
    useProxy: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      title: this.$i18n.t('connector.label.list_service'),
      fields: [
        {
          saved: {
            label: this.$i18n.t('label.saved'),
            sortable: true,
            tdClass: 'align-middle',
          }
        },        
        {
          serv_name: {
            label: this.$i18n.t('label.name'),
            sortable: true,
            tdClass: "align-middle",
          },
        },
        {
          ext_uri: {
            label: this.$i18n.t('connector.label.uriterranga') ,
            sortable: true,
            tdClass: "align-middle",
          },
        },
        {
          serv_id: {
            label: this.$i18n.t('label.identifiant') ,
            sortable: true,
            tdClass: "align-middle",
          },
        },
        {
          serv_is_default: {
            label: this.$i18n.t('label.default'),
            sortable: true,
            tdClass: "align-middle",
          },
        },        {
          update: {
            label: this.$i18n.t('label.action') ,
            sortable: false,
            tdClass: "align-middle",
          },
        },        

      ],
      secteurs: null,
      services: null,
      listVisible: false,
    };
  },
  async mounted() {
    this.getServices();
    this.listVisible = this.HasServices;
  },
  methods: {
    async SaveMapping(service){
      const result = await SetServiceUri(this.esta, this.cnt, service.serv_id, service.ext_uri)
      if (result) {
        service.old_uri = service.ext_uri;
        service.saved = true;
        service.modified = false;
      }
    },
    async getServices() {
      this.services = await MappedServices(this.esta, this.cnt);
    },
    rowClass(item, type) {
      if (!item || type !== "row") return;
      if (!item?.serv_is_enable) return "notenabled"      
      if (item.saved) return "gosted";
      if (item?.ext_uri !== ""  ) return "uncompleted";
    },

    checkMapping(){
      this.services.map(s => {
        s.modified = false
        s.old_uri = s.ext_uri;
        if (s.ext_uri === null){
          s.ext_uri =this.checkSecteur(s.serv_name);
          if (s.ext_uri) {
            s.modified = true;
            s.saved = true;
          }
        }
        return s;
      })
    },
    checkSecteur(label) {
      // Force la normalisation car différent selon la source
      let vlabel = normalizeSync(label);

      const i = this.secteurs.find((s) => {
          if( s?.label) {
            const text = normalizeSync(s.Label);
            return vlabel.includes(text);
          }
          return false;
      });
      if (i) return i.Uri;
      return null;
    },
    setSecteurs(result) {
      this.secteurs = result.data.map((m) => {
        return {
          Libelle: m.Libelle,
          Enabled: m.Actif === "1",
          Uri: m.Uri,
        };
      });
      this.checkMapping();

    },
    async getFromAPI(){
      let values;
      if (this.connector === 'NETSOIN') {
        if (this.useProxy) {
          const api = new ApiNetsoins(this.keyapi, this.urlapi, this.type);
          values = await api.getSectors()
        }
        else if (this.type === "SECTEUR")
          values = await Secteurs({uri:this.urlapi, key:this.keyapi});
        else
          values = await SousSecteurs({uri:this.urlapi, key:this.keyapi});
      } else if (this.connector === 'TITAN') {
        const api = new ApiTitan(this.config.apilogin, this.config.apipassword, this.config.apikey, this.config.apiurl, this.config.ext_uri);
        values = (await api.getSectors())
          .map(normalizeTitanSector)
          .sort((a, b) => a.Libelle.toLowerCase().localeCompare(b.Libelle.toLowerCase()))
      }
      if (values) {
        this.setSecteurs({data: values});
      }
    },
    setModified(_,item){
      item.modified = (item.old_uri !== item.ext_uri);
      item.saved = !(item.old_uri !== item.ext_uri );
    },
    Undo(item){
      item.ext_uri = item.old_uri;
      item.modified = false;
      item.saved = (item.old_uri === item.ext_uri && item.ext_uri !== null);
    },
    Reset(item){
      item.ext_uri = null;
      item.modified = (item.old_uri !== item.ext_uri);
      item.saved = !(item.old_uri !== item.ext_uri );      
    },
    GetLink(){
      var link = Links( (this.type === "SECTEUR") ?"secteurs": "soussecteurs", {uri:this.urlapi, key:this.keyapi});
      if (link) {
        Object.assign(document.createElement('a'), { target: '_blank', href: link }).click();
      }
    }    
  },
  computed:{   
    HasImport(){
      return this.keyapi !== null && this.urlapi !== null && this.HasServices;
    },
    HasServices() {
      return !!this.services;
    },
    SaveEnabled() {
      return (!!this.ctx && this?.ctx > 0 );
    }
}
};
</script>
<style>
.notenabled {
  color: lightgray;
  background-color: gray;
  text-decoration-line: line-through;
}
.gosted {
  color: grey;
  background-color: lightgray;
}
.uncompleted {
  color: red;
  background-color: rgb(247, 222, 222);
}
.details {
  display: flex;
}
.editbtn {
  margin-left: 0.2rem;
}
</style>
